import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'birdhouseWood',
      d: 'M-2.5,-1h0.5v0.5h-0.5zM0.5,-1h1v0.5h-1zM-3.5,-0.5h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM-3,0.5h2.5v0.5h-2.5zM3,0.5h0.5v0.5h-0.5zM-1,1h1.5v0.5h-1.5z',
    },
    { paint: 'gardenSoil', d: 'M-2,-0.5h3v0.5h-3zM-1,0h3v0.5h-3zM0.5,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['birdhouseWood', 0.74],
        ['shadow', 0.26],
      ],
      d: 'M-2,-1h1v0.5h-1zM-0.5,-1h1v0.5h-1zM-3,-0.5h0.5v0.5h-0.5zM1.5,-0.5h1.5v0.5h-1.5zM-2,0h0.5v0.5h-0.5zM2,0h1.5v0.5h-1.5zM-0.5,0.5h1v0.5h-1zM1,0.5h2v0.5h-2zM0.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['eggWhite', 0.25],
        ['gardenSoil', 0.75],
      ],
      d: 'M-1,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 55,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'birdhouseWood',
      d: 'M-2.5,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM-3,0.5h2.5v0.5h-2.5zM3,0.5h0.5v0.5h-0.5zM-1,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'gardenSoil',
      d: 'M-2,-0.5h1.5v0.5h-1.5zM0,-0.5h1v0.5h-1zM-1,0h0.5v0.5h-0.5zM0,0h1.5v0.5h-1.5zM0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['birdhouseWood', 0.74],
        ['shadow', 0.26],
      ],
      d: 'M-2,-1h1v0.5h-1zM-3,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-2,0h0.5v0.5h-0.5zM2,0h1.5v0.5h-1.5zM-0.5,0.5h1v0.5h-1zM1,0.5h2v0.5h-2zM0.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['eggWhite', 0.25],
        ['gardenSoil', 0.75],
      ],
      d: 'M-2.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h0.5v1h-0.5zM1.5,-0.5h0.5v1h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'sproutGreen',
      d: 'M-2.5,-1.5h1.5v0.5h-1.5zM-1,-1h1.5v0.5h-1.5zM1,-1h0.5v1h-0.5zM2,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['eggWhite', 0.32],
        ['sproutGreen', 0.68],
      ],
      d: 'M1.5,-1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 60,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'fence', d: 'M-3,-2h1v0.5h-1zM2,-2h1v1.5h-1zM-3,-1h1v0.5h-1z' },
    {
      paint: [
        ['eggWhite', 0.24],
        ['fence', 0.76],
      ],
      d: 'M0.5,-2h1.5v0.5h-1.5zM-3,-1.5h1.5v0.5h-1.5zM-1,-1.5h0.5v0.5h-0.5zM0,-1.5h2v0.5h-2z',
    },
    {
      paint: 'birdhouseWood',
      d: 'M-3.5,-0.5h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM-3,0.5h2.5v0.5h-2.5zM3,0.5h0.5v0.5h-0.5zM-1,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'gardenSoil',
      d: 'M-2,-0.5h1v0.5h-1zM-0.5,-0.5h1v0.5h-1zM-1,0h2v0.5h-2zM1.5,0h0.5v0.5h-0.5zM0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['birdhouseWood', 0.74],
        ['shadow', 0.26],
      ],
      d: 'M-2,-1h0.5v0.5h-0.5zM-0.5,-1h1v0.5h-1zM-3,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-2,0h0.5v0.5h-0.5zM2,0h1.5v0.5h-1.5zM-0.5,0.5h1v0.5h-1zM1,0.5h2v0.5h-2zM0.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['eggWhite', 0.25],
        ['gardenSoil', 0.75],
      ],
      d: 'M-1.5,-1h1v0.5h-1zM-2.5,-0.5h0.5v0.5h-0.5zM-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h1.5v0.5h-1.5zM-1.5,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z',
    },
    { paint: 'sproutGreen', d: 'M0.5,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5z' },
    {
      paint: [
        ['eggWhite', 0.32],
        ['sproutGreen', 0.68],
      ],
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 78,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
